<template>
  <div :class="isVip? 'vip_head_layout' : 'head_layout'">
    <div class="back2"></div>
    <div class="content_layout">
      <div class="vip_tip_layout">
        <div class='vip_tip_icon'>
          <img class="robotImg" :src="robotImg"></img>
        </div>

        <div :class="isVip? 'vip_tip_text_back' : 'tip_text_back'">
          {{ tipMsgCompute }}
        </div>
      </div>
      <template v-if="needAiOpen">
        <div class="card_layout">
          <div class="vip_card_layout1" style="margin-top: 1rem;">
            <div class="tip_msg" v-if="!isVip">重新开启并购买会员即可<span class="gold">无限制</span>使用</div>
            <div class="tip_msg" v-if="isVip">重新开启即可<span class="gold">无限制</span>使用</div>
          </div>
          <div class="vip_reopen" @click="openService">重新开启服务</div>
        </div>

      </template>
      <template v-else>
        <template v-if="outOfData">
          <div class="card_layout">
            <div class="hint_layout" style="margin-top: 1rem;">
              <img class="hint_img" src="../../assets/hint.png"> <span class="hint_msg">服务已失效  运营商限制将导致扣话费风险</span>
            </div>
            <div class="vip_card_layout2">
              <div class="close_aicall" @click="closeService">关闭服务免扣费</div>
              <div class="open_vip" @click="openVip">开通会员放心用</div>
            </div>
          </div>
        </template>
        <template v-else>

          <div class="vip_card_layout" v-if="isVip">
            <div class="vip_card_layout1">
              <div class="vip_tip_msg">{{ cardTipmsg }}</div>
              <div class="vip_renew" @click="openVip">续费会员</div>
            </div>

            <div class="vip_card_layout2">
              <div class="card_setting_item" @click="goAiSoundPage">
                <img :src="vipRoleImg"></img>
                <div class="vip_card_setting_item_title">助理声音</div>
              </div>
              <div class="card_setting_item" @click="goFirstTalkPage">
                <img :src="vipFirstMsgImg"></img>
                <div class="vip_card_setting_item_title">接听开场白</div>
              </div>
              <div class="card_setting_item" @click="goRefusePage">
                <img :src="vipRefuseImg"></img>
                <div class="vip_card_setting_item_title">谢绝骚扰来电</div>
              </div>
              <div class="card_setting_item" @click="goVipSettingPage">
                <img :src="vipMoreImg">
                <div class="vip_card_setting_item_title">定制服务</div>
              </div>
            </div>
          </div>

          <div class="card_layout" v-else>
            <div class="vip_card_layout1">
              <div class="tip_msg">会员享<span class="gold">无限次</span>使用等24项特权</div>
              <div class="vip_open_button" @click="openVip">开通会员</div>
            </div>

            <div class="vip_card_layout2">
              <div class="card_setting_item" @click="goAiSoundPage">
                <img :src="vipRoleImg"></img>
                <div class="card_setting_item_title">助理声音</div>
              </div>
              <div class="card_setting_item" @click="goFirstTalkPage">
                <img :src="vipFirstMsgImg"></img>
                <div class="card_setting_item_title">接听开场白</div>
              </div>
              <div class="card_setting_item" @click="goRefusePage">
                <img :src="vipRefuseImg"></img>
                <div class="card_setting_item_title">谢绝骚扰来电</div>
              </div>
              <div class="card_setting_item" @click="goVipSettingPage">
                <img :src="vipMoreImg">
                <div class="card_setting_item_title">定制服务</div>
              </div>
            </div>
          </div>

        </template>
      </template>
    </div>
  </div>
</template>

<script>

import irobot_gray from '@/assets/irobot_vip.png'
import irobot from '@/assets/irobot_vip.png'

import vip_role_img2 from '@/assets/icon_role2.png'
import vip_refuse_img2 from '@/assets/icon_refuse2.png'
import vip_firstmsg_img2 from '@/assets/icon_firstmsg2.png'
import vip_more_img2 from '@/assets/icon_normal2.png'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

const TAG = '[VipHead]'

export default {
  inject: ['reload'],
  name: 'VipHead',
  data () {
    return {
      cardTipmsg: '会员用户',
      robotImg: irobot,
      isVip: false,
      vipRoleImg: vip_role_img2,
      vipRefuseImg: vip_refuse_img2,
      vipFirstMsgImg: vip_firstmsg_img2,
      vipMoreImg: vip_more_img2
    }
  },
  props: {
    vipInfo: {
      type: Object,
      default: {}
    },
    msgCount: {
      type: Number,
      default: 0
    },
    outOfData: {
      type: Boolean,
      default: false
    },
    needAiOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goAiSoundPage () {
      this.$router.push({
        path: '/ai_sound_page'
      })
      lubanapi.reportseer(this.isVip ? 'AICall_Home_Page_Member_Within_Period_Introduction_Click_Icon1' : 'AICall_Home_Page_Not_Member_Can_Try_Rights_Introduction_Click_Icon1')
    },

    goFirstTalkPage () {
      this.$router.push({
        path: '/vip_prologue_page'
      })
      lubanapi.reportseer(this.isVip ? 'AICall_Home_Page_Member_Within_Period_Introduction_Click_Icon2' : 'AICall_Home_Page_Not_Member_Can_Try_Rights_Introduction_Click_Icon2')
    },

    goRefusePage () {
      this.$router.push({
        path: '/vip_refuse_page'
      })
      lubanapi.reportseer(this.isVip ? 'AICall_Home_Page_Member_Within_Period_Introduction_Click_Icon3' : 'AICall_Home_Page_Not_Member_Can_Try_Rights_Introduction_Click_Icon3')
    },

    goVipSettingPage () {
      this.$router.push({
        path: '/vip_setting_page'
      })
      lubanapi.reportseer(this.isVip ? 'AICall_Home_Page_Member_Within_Period_Introduction_Click_Icon4' : 'AICall_Home_Page_Not_Member_Can_Try_Rights_Introduction_Click_Icon4')
    },

    openService () {
      this.$router.push({
        name: 'bind_call_forward',
        params: {
          from: 'server'
        }
      })
      lubanapi.reportseer('AICall_Home_Page_Shown_Service_Close_Open_Button_Click')
    },
    closeService () {
      this.$router.push({
        name: 'closeaipage'
      })
      lubanapi.reportseer('AICall_Home_Page_Member_Without_Period_Close_Button_Click')
    },
    openVip () {
      jsbridge.openVip(this)
      if (this.isVip) {
        lubanapi.reportseer('AICall_Home_Page_Member_Within_Period_Renewal_Member_Click')
      } else {
        lubanapi.reportseer('AICall_Home_Page_Member_Without_Period_Renewal_Member_Click')
        // 可试用的情况下 点击vip
        if (this.msgCount < 3) {
          lubanapi.reportseer('AICall_Home_Page_Not_Member_Can_Try_Understand_Member_Click')
        } else {
          lubanapi.reportseer('AICall_Home_Page_Not_Member_Can_Not_Try_Understand_Member_Click')
        }
      }
      lubanapi.reportseer('AICall_Goto_Member_Centre_Total', 'vipHead')
    },
    formatVipDate () {
      try {
        var date = new Date(this.vipInfo.expireTime * 1000)
        var endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        this.cardTipmsg = '会员用户|' + endTime + '到期'
      } catch (err) {
        this.cardTipmsg = '会员用户'
      }
    },
    updateVipInfo () {
      if (this.vipInfo.vipStatus === 1) {
        this.robotImg = irobot
        this.isVip = true

        // this.vipRoleImg = vip_role_img1
        // this.vipRefuseImg = vip_refuse_img1
        // this.vipFirstMsgImg = vip_firstmsg_img1
        // this.vipMoreImg = vip_more_img1
        //
        this.formatVipDate()
      } else {
        this.robotImg = irobot_gray
        this.isVip = false

        // this.vipRoleImg = vip_role_img2
        // this.vipRefuseImg = vip_refuse_img2
        // this.vipFirstMsgImg = vip_firstmsg_img2
        // this.vipMoreImg = vip_more_img2
      }
    }
  },
  mounted () {
    console.log(TAG, 'vipInfo', this.vipInfo)
    this.updateVipInfo()
  },
  computed: {
    tipMsgCompute: function () {
      var tipMsg = null
      if (this.isVip) {
        if (this.msgCount == 0) {
          tipMsg = '智能接听助理持续为您服务中'
        } else {
          tipMsg = '已为你接听' + this.msgCount + '次 节约' + (this.msgCount) * 1.5 + '分钟'
        }
      } else {
        if (this.msgCount < 3) {
          tipMsg = '剩余免费' + (3 - this.msgCount) + '次接听机会'
        } else {
          tipMsg = '已为你接听' + this.msgCount + '次 节约' + (this.msgCount) * 1.5 + '分钟'
        }
      }

      if (this.needAiOpen) {
        return '服务已关闭|' + tipMsg
      } else if (this.outOfData) {
        if (this.vipInfo.vipStatus == 2) {
          lubanapi.reportseer('AICall_Home_Page_Shown_Member_Without_Period')
          return '会员已过期|' + tipMsg
        } else {
          return '试用结束|' + tipMsg
        }
      } else {
        return tipMsg
      }
    }
  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    vipInfo: function (newInfo, oldInfo) {
      console.log(TAG, 'watch', newInfo)
      this.updateVipInfo()
    }
  },
}
</script>
<style scoped>
.head_layout {
  position: relative;
  height: 12.5rem;
  width: 100%;
  background: linear-gradient(0deg, #389EFE 0%, #1259FF 100%);
  box-sizing: border-box;
}

.vip_head_layout {
  position: relative;
  height: 12.5rem;
  width: 100%;
  background: linear-gradient(0deg, #26282D 0%, #111118 100%);
  box-sizing: border-box;
}

.content_layout {
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  position: absolute;
  width: 100%;
  height: 100%;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  top: 0;
  left: 0;
  box-sizing: border-box;
}

.back2 {
  position: absolute;
  bottom: 0;
  height: 3rem;
  width: 100%;
  background: #F7F7F9;
}

.vip_tip_layout {
  width: 100%;
  height: 3.03rem;
  /*background: #42b983;*/
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.vip_tip_icon {
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  /*background: #2260FD;*/
  /*background: linear-gradient(134deg, #2260FD 0%, #8B26FF 100%);*/
  background: linear-gradient(134deg, #19F2FF 0%, #6C26FF 100%);
  border-radius: 1.25rem;
  top: 50%;
  transform: translate(0, -50%);
}

.vip_tip_icon_gray {
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  background: #BFBFBF;
  border-radius: 1.25rem;
  top: 50%;
  transform: translate(0, -50%);
}

.robotImg {
  position: absolute;
  width: 1.905rem;
  height: 1.905rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vip_tip_text_back {
  position: absolute;
  min-width: 5rem;
  max-width: 20rem;
  line-height: 2rem;
  height: 2rem;
  left: 3.5rem;
  border-radius: 0.2rem;
  top: 50%;
  transform: translate(0, -50%);
  background: #073ABA;

  color: white;
  font-size: 0.8rem;
  font-family: PingFangSC-Regular;
  word-break: break-all;
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.vip_tip_text_back:after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translate(0, -50%);
  width: 0;
  height: 0;
  border-width: 0.3rem;
  border-style: solid;
  border-color: transparent;
  border-right-width: 0.5rem;
  border-right-color: currentColor;
  color: #073ABA;
}


.tip_text_back {
  position: absolute;
  min-width: 5rem;
  max-width: 20rem;

  height: 2rem;
  left: 3.5rem;
  border-radius: 0.2rem;
  top: 50%;
  transform: translate(0, -50%);
  background: #0E48DA;
  /*opacity: 0.3;*/

  color: white;
  font-size: 0.8rem;
  font-family: PingFangSC-Regular;
  word-break: break-all;
  line-height: 2rem;
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.tip_text_back:after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translate(0, -50%);
  width: 0;
  height: 0;
  border-width: 0.3rem;
  border-style: solid;
  border-color: transparent;
  border-right-width: 0.5rem;
  border-right-color: currentColor;
  color: #0E48DA;
}


.card_layout {
  width: 100%;
  height: 8.15rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  /*background: url(../../assets/vip_back.png)  no-repeat right top,linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);*/
  background: white;
  background-size: 40%, 100%;
}


.vip_card_layout {
  width: 100%;
  height: 8.15rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  background: white;
}

.vip_card_layout1 {
  width: 100%;
  height: 1.7rem;
  position: relative;
  margin-top: 0.94rem;
  margin-bottom: 0.5rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  box-sizing: border-box;
}

.hint_layout {
  width: 100%;
  height: 1.5rem;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.vip_card_layout2 {
  width: 100%;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  /*padding-left: 1rem;*/
  /*padding-right: 1rem;*/
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
}

.vip_tip_msg {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #000000;
  letter-spacing: 0;
  float: left;
  font-width: 500;
  line-height: 1.7rem;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.tip_msg {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: black;
  letter-spacing: 0;
  float: left;
  font-width: 500;
  line-height: 1rem;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.hint_msg {
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  color: #FE5142;
  letter-spacing: 0;
  line-height: 1.08rem;
}

.hint_img {
  width: 1.08rem;
  height: 1.08rem;
  margin-right: 0.2rem;
}

.vip_open_button {
  width: 4.4rem;
  height: 1.7rem;
  background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);
  border-radius: 27px;

  font-family: PingFangSC-Medium;
  font-size: 0.815rem;
  line-height: 1.7rem;
  color: #FFE9B7;
  letter-spacing: 0;
  text-align: center;
  float: right;


  border: 1px solid transparent;
  box-sizing: border-box;
}


.vip_renew {
  width: 4.4rem;
  height: 1.7rem;
  background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);
  border-radius: 27px;

  font-family: PingFangSC-Medium;
  font-size: 0.815rem;
  line-height: 1.7rem;
  color: #FFE9B7;
  letter-spacing: 0;
  text-align: center;
  float: right;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.card_setting_item {
  flex: 1;
}

.card_setting_item img {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 0.95rem;
  /*background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);*/
}

.card_setting_item_title {
  opacity: 0.7;
  font-family: PingFangSC-Regular;
  font-size: 0.7rem;
  color: #000000;
  text-align: center;
  margin-top: 0.5rem;
  font-weight: 600;
}

.vip_card_setting_item_title {
  opacity: 0.7;
  font-family: PingFangSC-Regular;
  font-size: 0.7rem;
  color: #000000;
  text-align: center;
  margin-top: 0.5rem;
}

.gold {
  color: #ffb959;
}

.vip_reopen {
  box-sizing: border-box;
  width: calc(100% - 1.6rem);
  height: 2.8rem;
  margin-top: 0.4rem;
  background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 2.6rem;
  color: #FFE9B7;

  border: 1px solid transparent;
  box-sizing: border-box;
}

.close_aicall {
  flex: 1;
  height: 2.8rem;
  border: 0.08rem solid #000000;
  border-radius: 0.28rem;
  margin-left: 0.75rem;
  margin-right: 0.375rem;
  font-size: 1rem;
  line-height: 2.8rem;
  color: #000000;
  box-sizing: border-box;
}

.open_vip {
  flex: 1;
  height: 2.8rem;
  background-image: linear-gradient(134deg, #3B3D42 0%, #1F2029 100%);;
  border-radius: 0.28rem;
  margin-left: 0.375rem;
  margin-right: 0.75rem;
  font-size: 1rem;
  line-height: 2.8rem;
  color: #FFE9B7;

  border: 1px solid transparent;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/widgets/VipHead.vue